import React from "react";
import { CoachClientNotesScreen } from "../../../../components/screen/CoachClientNotesScreen";

export function CoachClientNotesRoute() {
  return <CoachClientNotesScreen />;
}
